module.exports = __webpack_public_path__ + "static/img/Christian-Welch.f635162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Christian-Welch.jpg
// module id = jC3i
// module chunks = 0